
import { EarlyAccessLead } from '@/types/early-access';

export const exportToCSV = (leads: EarlyAccessLead[]) => {
  const headers = [
    'Date', 'Name', 'Email', 'Motivation', 'Other Motivation', 
    'Experience', 'Current App', 'Challenge', 'Use Case', 'Other Use Case', 
    'Interview Interest'
  ];

  const csvData = leads.map(lead => [
    new Date(lead.created_at).toLocaleDateString('es-ES'),
    lead.first_name,
    lead.email,
    lead.motivation,
    lead.motivation_other || '',
    lead.experience,
    lead.current_habit_app || '',
    lead.challenge,
    lead.use_case,
    lead.use_case_other || '',
    lead.interview_interest
  ]);

  const csvContent = [headers, ...csvData]
    .map(row => row.map(field => `"${field}"`).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `early-access-leads-${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
